import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { DSIcon } from '@spotahome/ui-library/base';

import './SimpleValuePropositions.scss';

const RESPONSE_RATE_TITLE_KEY = {
  4: 'property_show.book_now_card.response_rate.high.title',
  3: 'property_show.book_now_card.response_rate.medium.title',
  2: 'property_show.book_now_card.response_rate.low.title'
};

const STATIC_ITEMS = [
  {
    key: 'no-charge',
    icon: 'person_add',
    transKey: 'listing.simple-vp.no-charge'
  },
  {
    key: 'free-cancellation',
    icon: 'verified_user',
    transKey: 'listing.simple-vp.free-cancellation'
  }
];

const SimpleValuePropositions = ({ responseRateState = null }) => {
  const landlordReplyTransKey =
    RESPONSE_RATE_TITLE_KEY[responseRateState] ?? 'listing.simple-vp.landlord-reply';

  return (
    <ul className="simple-value-propositions">
      {STATIC_ITEMS.map(({ key, icon, transKey }) => (
        <li key={key} className="simple-value-propositions__item">
          <DSIcon name={icon} size="m" />
          <span className="simple-value-propositions__text">{trans(transKey)}</span>
        </li>
      ))}
      <li key="landlord-reply" className="simple-value-propositions__item">
        <DSIcon name="quick_phrases" size="m" />
        <span className="simple-value-propositions__text">{trans(landlordReplyTransKey)}</span>
      </li>
    </ul>
  );
};

SimpleValuePropositions.propTypes = {
  responseRateState: PropTypes.number
};

export default SimpleValuePropositions;
